// extracted by mini-css-extract-plugin
export default {"card-icon-expand-div":"DragPanel_card-icon-expand-div__tDlMs","card-icon-drag-div":"DragPanel_card-icon-drag-div__OjrC+","card-icon-left":"DragPanel_card-icon-left__FtfLC"};